import type { ExportItemType } from '../common/types.tsx';
import type { useFetchAllExportIssuesResources } from '../services/export-issues/index.tsx';
import { ECOSYSTEM_APPS_GROUP_INDEX } from './constants.tsx';

const getAllExportItems = (
	data: ReturnType<typeof useFetchAllExportIssuesResources>['exportItems'],
): ExportItemType[][] | undefined => data && data.filter && data.filter.map((group) => group.items);

export const getExportItems = (
	data: ReturnType<typeof useFetchAllExportIssuesResources>['exportItems'],
): ExportItemType[][] | undefined => getAllExportItems(data);

/** Alphabetically orders connect apps by their labels. Note this function will modify the original array as well.  */
export const sortConnectAppsInExportItems = (
	exportItems: ExportItemType[][] | undefined,
	intlCollator: Intl.Collator,
): ExportItemType[][] | undefined => {
	const orderedExportItems = exportItems;
	orderedExportItems != null &&
		orderedExportItems.length > ECOSYSTEM_APPS_GROUP_INDEX &&
		orderedExportItems[ECOSYSTEM_APPS_GROUP_INDEX]?.sort((a: ExportItemType, b: ExportItemType) =>
			intlCollator.compare(a.label, b.label),
		);

	return orderedExportItems;
};

const receiveSameDomainOverride = (params: { s: string }) => {
	const { s: command } = params;

	if (command !== 'hideLoading' && command !== 'showLoading') {
		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		window.gadgets.rpc.originalReceiveSameDomain(params);
	}
};

export const overrideIframeRpcCall = () => {
	// NOTE - In the past iframe gadgets in dashboards use rpc calls to talk to SPA but
	// we don't do it in NIN. A noop needs to be registered to showLoading and hideLoading
	// to overwrite the original that would throw an error. This is a temporary measure to
	// prevent Sentry noise - iframe gadgets will be deprecated in the near future.
	if (
		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		window?.gadgets?.rpc?.receiveSameDomain &&
		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		window.gadgets.rpc.receiveSameDomain !== receiveSameDomainOverride
	) {
		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		window.gadgets.rpc.originalReceiveSameDomain = window.gadgets.rpc.receiveSameDomain;

		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		window.gadgets.rpc.receiveSameDomain = receiveSameDomainOverride;
	}
};
